module.exports = __webpack_public_path__ + "img/icn_lower.60cebaf2.svg";